/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon16Solid = forwardRef('ArrowUiAuthLoginIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 3.5A2.5 2.5 0 0 0 12.5 1h-6A2.5 2.5 0 0 0 4 3.5V7H1a1 1 0 0 0 0 2h3v3.5A2.5 2.5 0 0 0 6.5 15h6a2.5 2.5 0 0 0 2.5-2.5v-9ZM4 9h5.086l-1.793 1.793a1 1 0 1 0 1.414 1.414l3.003-3.003a1.703 1.703 0 0 0 0-2.408L8.707 3.793a1 1 0 1 0-1.414 1.414L9.086 7H4v2Z" })));
});
